<template>
    <div>
        <VueCustomTooltip :label="`${$ml.get('multipliedScore')} ${bonusScoreValue}x`">
            <span class="ico ico-locked">
                <img
                src="../assets/icons/star-icon.svg"
                class="ico-12"
                />
            </span>
        </VueCustomTooltip>
    </div>
</template>

<script>
export default {
    props: {
       bonusScoreValue: {
            type: Number,
            required: true
       } 
    },
}
</script>
